import { useState, useEffect } from "react";
import { fetchJudgmentData } from "../api/judgment/fetch-api";
import { toDatetimeStr } from "../utils/datetime-utils";
import { errorStatusHandle } from "../utils/error-utils";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  clearComponentLoading,
  clearPageLoading,
  setComponentLoading,
  clearButtonProcessing,
  setAlertError,
  setAlertSuccess,
} from "../store/actions";
import { getSortParams } from "../utils/common-utils";

const useInspectionData = (filter, reload) => {
  const [inspections, setInspections] = useState();
  const [requireJudgmentNumber, setRequireJudgmentNumber] = useState();
  const [workflow, setWorkflow] = useState();
  const [tableData, setTableData] = useState([]);
  const [noSortData, setNoSortData] = useState([]);
  const [myPageInspection, setMyPageInspection] = useState(null);
  const [params, setParams] = useSearchParams();
  const dispatch = useDispatch();
  const [displayColumns, setDisplayColumns] = useState({
    group_1: false,
    group_2: false,
    group_3: false,
    group_4: false,
    group_5: false,
    machine_name: true,
    inspection_number: true,
    result: true,
    registration_datetime: true,
    operation_start_user_id: null,
    operation_start_datetime: null,
    inspection_start_user_id: true,
    inspection_start_datetime: true,
    last_treatment_user: true,
    last_treatment_datetime: false,
    judgment_0: true,
    judgment_1: true,
    judgment_2: true,
    judgment_3: true,
    judgment_4: false,
    judgment_5: false,
    judgment_6: false,
    judgment_7: false,
    judgment_8: false,
    judgment_9: false,
  });
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [numPages, setNumPages] = useState(1);
  const [count, setCount] = useState(0);
  const [orderList, setOrderList] = useState({
    machine_name: 0,
    result: 0,
    registration_datetime: 0,
    last_treatment_user: 0,
    name_1: 0,
    name_2: 0,
    name_3: 0,
    name_4: 0,
    name_5: 0,
    name_6: 0,
    name_7: 0,
    name_8: 0,
    name_9: 0,
    name_10: 0,
  });

  useEffect(() => {
    if (filter.workflowId) {
      let sort = getSortParams(orderList);
      dispatch(setComponentLoading("judgment"));
      fetchJudgmentData({ ...filter, page, perPage, sort })
        .then((res) => {
          setInspections(res.inspections);
          setWorkflow(res.workflow);
          setCount(res.count);
          setNumPages(res.num_pages);
          dispatch(clearComponentLoading("judgment"));
          dispatch(clearButtonProcessing("btn-search-judgment"));
          if (params.get("inspection") && params.get("workflow")) {
            setMyPageInspection(params.get("inspection"));
          }
        })
        .catch((e) => {
          setInspections([]);
          setCount(0);
          setNumPages(0);
          dispatch(setAlertError(Object.values(e.response?.data)));
          dispatch(clearButtonProcessing("btn-search-judgment"));
          dispatch(clearComponentLoading("judgment"));
          dispatch(clearPageLoading());
          errorStatusHandle(e.response);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, reload, page, perPage, orderList]);

  useEffect(() => {
    const tmp = inspections?.map((inspection) => {
      let result = {
        id: inspection.id,
        machine_id: inspection.machine.id,
        template: inspection.template,
        inspection_number: inspection.inspection_number,
        approve_order: inspection.approve_order,
        group_1: inspection.machine.group_relation.group_1?.name,
        group_2: inspection.machine.group_relation.group_2?.name,
        group_3: inspection.machine.group_relation.group_3?.name,
        group_4: inspection.machine.group_relation.group_4?.name,
        group_5: inspection.machine.group_relation.group_5?.name,
        machine_name: inspection.machine.name,
        result: inspection.result,
        registration_datetime: toDatetimeStr(inspection.registration_datetime),
        operation_start_user_id: inspection.operation_start_user
          ? `${inspection.operation_start_user.name} (${inspection.operation_start_user.username})`
          : "-",
        operation_start_datetime: inspection.operation_start_datetime
          ? toDatetimeStr(inspection.operation_start_datetime)
          : "-",
        inspection_start_user_id: `${inspection.inspection_start_user.name} (${inspection.inspection_start_user.username})`,
        inspection_start_datetime: toDatetimeStr(
          inspection.inspection_start_datetime
        ),
        last_treatment_user: inspection.last_treatment_username
          ? `${inspection.last_treatment_user}(${inspection.last_treatment_username})`
          : "-",
        last_treatment_datetime: inspection.last_treatment_datetime
          ? toDatetimeStr(inspection.last_treatment_datetime)
          : "-",
        items: inspection.items,
        checked: false,
      };
      workflow?.sequences.forEach((element, order) => {
        if (
          (inspection.judgments[order] && order === 0 && !inspection.judgments[order]?.result) ||
          (inspection.judgments[order] && inspection.approve_order !== order)
        ) {
          let judgmentOrderResult = inspection.judgments[order]?.result ? 1 : 0;
          result["judgment_" + order + "_result"] = judgmentOrderResult;
          result[
            "judgment_" + order
          ] = `${inspection.judgments[order]?.judgment_user.name}(${inspection.judgments[order]?.judgment_user.username})`;
        } else {
          result["judgment_" + order] = "判定前";
        }
      });
      return result;
    });
    setTableData(tmp);
    setNoSortData(tmp);
  }, [inspections, workflow]);

  return {
    inspections,
    setInspections,
    workflow,
    setWorkflow,
    requireJudgmentNumber,
    setRequireJudgmentNumber,
    tableData,
    setTableData,
    noSortData,
    setNoSortData,
    displayColumns,
    setDisplayColumns,
    myPageInspection,
    setMyPageInspection,
    page,
    perPage,
    numPages,
    count,
    orderList,
    setPage,
    setPerPage,
    setNumPages,
    setCount,
    setOrderList,
  };
};

export default useInspectionData;
